import React from 'react';
import { Col, Row } from 'reactstrap';
import { components } from 'react-select';
import AsyncSelect from 'react-select/async';

const CustomSearch = (props) => {
    const { loadOptions, handleInputChange, customStyles,icon,placeHolder } = props

    const Control = ({ children, ...props }) => (
        <components.Control {...props}>
             {icon}{children}
        </components.Control>
    );
    return (
        <div>
            <Row style={{ display: 'flex', justifyContent: 'center' }}>
                <Col lg="12" md="12">
                    <AsyncSelect
                        styles={customStyles}
                        placeholder={placeHolder}
                        loadOptions={loadOptions}
                        onChange={handleInputChange}
                        cacheOptions
                        isClearable={false}
                        openMenuOnClick={true}
                        closeMenuOnScroll={true}
                        controlShouldRenderValue={false}
                        backspaceRemovesValue={false}

                        components={{
                            Control,
                            DropdownIndicator: () => null,
                            IndicatorSeparator: () => null
                        }}
                    />
                </Col>
            </Row>
        </div>
    );
}

export default CustomSearch;

